import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../../lib/analytics";

/**
 * Fires a GA4 page_view on every route change. No-op until consent is granted
 * and the analytics module has been initialised — both gates live inside
 * trackPageView itself.
 */
export const PageViewTracker = () => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    trackPageView(pathname + search, document.title);
  }, [pathname, search]);
  return null;
};

export default PageViewTracker;
